import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { ErrorStateMatcher } from '@angular/material';
import { TRANSLATE } from '../../shared/classes/translatable';
import { AlertService } from '../../shared/services/alert.service';
import { FactureFournisseurService } from '../../facturation/shared/services/facture-fournisseur.service';
import { FactureFournisseur } from '../../facturation/shared/classes/facture-fournisseur';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const invalidCtrl = !!(control && control.parent &&control.invalid && control.parent.dirty);
      const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
      return control.parent.errors && control.parent.errors  && control.touched && ( invalidCtrl || invalidParent );
    }
}

@Component({
  selector: 'app-validation-factures',
  templateUrl: './validation-factures.component.html',
  styleUrls: ['./validation-factures.component.css']
})
export class ValidationFacturesComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private factureFournisseurService: FactureFournisseurService
  ) { }

  validationForm: FormGroup;
  token: string = null;
  ffoId: string = null;
  tokenDatas: any;
  validation: number;
  facture: FactureFournisseur;
  factureRefused: boolean = false;
  invalidToken: boolean = false;
  deletedFacture: boolean = false;

  ngOnInit() {
    this.validationForm = this.formBuilder.group({
      motif: ['', Validators.required]
    });
  
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.validation = parseInt(params['validation']);
  
      if (this.token) {
        this.authService.decryptOneTimeToken(this.token).subscribe(retour => {
          if (retour.message === "Token invalide") {
            this.invalidToken = true;
          }
          
          if (retour.data && retour.data.ffo_id) {
            
            this.ffoId = retour.data.ffo_id;
            this.tokenDatas = retour.data.token;
            this.factureFournisseurService.fetchById(this.ffoId).subscribe(response => {
              if (response.status === 200) {
                this.facture = response.data;
                if (this.facture.ffo_suppression) {
                  this.deletedFacture = true;
                }
              }
            })
          }

          if (this.validation === 1) {
            this.onValidateFacture();
          }
        });
      } else {
        // Aucun token dans l'URL
        this.router.navigate(['/app-not-found']);
      }
    });
  }
  

  onValidateFacture() {
    let data = {
      motif: null, 
      validation: 1,
      ffoId: this.ffoId,
      roleId: this.tokenDatas.ott_role_id,
      token: this.tokenDatas.ott_token
    };
    this.factureFournisseurService.receptionValidationFournisseur(data).subscribe()
  }

  onRefuseFacture() {
    let data = {
      motif: this.validationForm.get("motif").value, 
      validation: 0,
      ffoId: this.ffoId,
      roleId: this.tokenDatas.ott_role_id,
      token: this.tokenDatas.ott_token
    };
    this.factureFournisseurService.receptionValidationFournisseur(data).subscribe(response => {
      if (response.status === 200) {
        this.factureRefused = true;
      }
    })
  }
}